import { AvField } from "availity-reactstrap-validation";
import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import { connect } from "react-redux";
import LegalEntityMultiSelect from "./LegalEntityMultiSelect";

const LegalEntityQuestion = ({
    t,
    id,
    title,
    isMandatory
}) => {
    const [ selectedLegalEntities, setSelectedLegalEntities ] = useState([]);

    return (
        <Row>
            <Col sm="12">
                <div className="mb-3">
                    <Label
                        className="form-label"
                        htmlFor={`legal-question-${id}`}
                    >
                        {t(title)}
                        {isMandatory ? (
                            <span className="text-danger"> *</span>
                        ) : null}
                    </Label>

                    <LegalEntityMultiSelect
                        value={selectedLegalEntities}
                        onChange={(e) => {
                            setSelectedLegalEntities(e)
                        }}
                        placeholder={`${t("Select")}...`}
                    />

                    <AvField
                        id={`legal-question-${id}`}
                        type="hidden"
                        name={`Questien[${id}]`}
                        value={selectedLegalEntities}
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: {
                                value: isMandatory
                            }
                        }}
                    />
                </div>
            </Col>
        </Row>
    )
}

const mapStatetoProps = (state) => {
    const { token, user } = state.Login;

    return {
        token,
        user
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps
    )(
        LegalEntityQuestion
    )
);